import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'

class PayService {
  private checkTimer: NodeJS.Timeout | null = null
  private currentOutTradeNo: string | null = null
  private sessionId: string = ''

  public async checkPayStatus(outTradeNo: string, sessionId: string, onPaySuccess?: () => void) {
    this.stopCheckPayStatus()
    if (!sessionId) {
      this.sessionId = commonUtils.genId()
      sessionId = this.sessionId
    }
    const {
      data: { pay },
    } = await api.goods.verifyWxPayOrder(outTradeNo)
    if (sessionId !== this.sessionId) {
      return
    }
    console.log('checkPayStatus', outTradeNo, pay)
    if (!pay) {
      this.checkTimer = setTimeout(() => {
        this.checkPayStatus(outTradeNo, sessionId, onPaySuccess)
      }, 1000)
      return
    }
    onPaySuccess?.()
  }

  public stopCheckPayStatus() {
    if (this.checkTimer) {
      clearTimeout(this.checkTimer)
      this.checkTimer = null
    }
  }

  public closePay() {
    this.stopCheckPayStatus()
    this.currentOutTradeNo = null
  }

  // 创建Native支付二维码
  public async createPayQrCode({
    goodsId,
    goodsType,
    chargeChannel,
    cb,
    onPaySuccess,
  }: {
    goodsId: string
    goodsType: DataModels.goods.GoodsType
    chargeChannel: 'wx_pub_qr' | 'alipay_qr'
    cb: (codeUrl: string) => void
    onPaySuccess?: () => void
  }) {
    const sessionId = commonUtils.genId()
    this.sessionId = sessionId
    const {
      data: { outTradeNo, codeUrl },
    } = await api.goods.createPayQrCode({
      goodsId,
      goodsType,
      chargeChannel,
    })
    if (sessionId !== this.sessionId) {
      return
    }
    this.currentOutTradeNo = outTradeNo
    cb(codeUrl)
    this.checkPayStatus(outTradeNo, sessionId, onPaySuccess)
  }

  /**
   * 创建H5支付URL
   * 微信浏览器调用jsapi支付 - 直接获取支付状态
   * 非微信浏览器调用H5支付 - 重定向到指定页面，自查支付状态
   * @returns
   */
  public async createH5Pay({
    goodsId,
    goodsType,
    onPaySuccess,
    chargeChannel,
  }: {
    goodsId: string
    goodsType: DataModels.goods.GoodsType
    onPaySuccess?: () => void
    chargeChannel: 'wx_pub_qr' | 'alipay_qr'
  }) {
    this.stopCheckPayStatus()

    //@ts-ignore
    if (typeof WeixinJSBridge == 'undefined') {
      // 非微信浏览器
      const {
        data: { outTradeNo, mwebUrl },
      } = await api.goods.createWxPayOrder({
        goodsId,
        goodsType,
        chargeChannel,
      })

      if (mwebUrl) {
        if (chargeChannel === 'wx_pub_qr') {
          window.location.href =
            mwebUrl +
            `&redirect_url=${encodeURIComponent(this.appendOutTradeNo('outTradeNo', outTradeNo))}`
        } else {
          window.location.href = mwebUrl
        }
      }
    } else {
      // 微信浏览器
      const sessionId = commonUtils.genId()
      this.sessionId = sessionId
      const {
        data: { jsapiParams, outTradeNo },
      } = await api.goods.createJsapiPayOrder({
        goodsId: goodsId,
        goodsType: goodsType,
      })
      if (sessionId !== this.sessionId) {
        return
      }

      this.currentOutTradeNo = outTradeNo

      return new Promise((resolve) => {
        //@ts-ignore
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: jsapiParams.appId,
            timeStamp: jsapiParams.timeStamp,
            nonceStr: jsapiParams.nonceStr,
            package: jsapiParams.package,
            signType: jsapiParams.signType,
            paySign: jsapiParams.paySign,
          },
          (res: any) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              onPaySuccess?.()
            }
            resolve(res)
          }
        )
      })
    }
  }

  /*
   * 将outTradeNo参数添加或更新到当前URL
   *@param outTradeNo 要添加的outTradeNo值
   *@returns 处理后的URL
   */
  public appendOutTradeNo(key: string, value: string): string {
    // 创建一个URL对象解析当前地址
    const url = new URL(window.location.href)
    // 获取URL中的查询参数
    const searchParams = url.searchParams
    // 设置或更新outTradeNo参数（如果已存在则会替换）
    searchParams.set(key, value)
    // 返回更新后的URL
    console.log('appendOutTradeNo', url.toString())
    return url.toString()
  }
}

export const payService = new PayService()
